import basicController from "servicestack/basic.controller.properties";
import AutoQuery from "servicestack/auto-query/auto-query";
import ServiceBus from "servicestack/service-bus";
import modals from "webmodals/modals";
import $appConfig from "servicestack/config";
import swatchConfig from "emun.swatch/swatch.config";
export default class SwatchCountEditController {
  constructor() {
    let $ctrl = this;
    basicController(this);
    $ctrl.checkSwatchBusy = false;
    $ctrl.swatchConfig = swatchConfig;
    const id = $ctrl.countId;
    $ctrl.bus = new ServiceBus();
    $ctrl.$appConfig = $appConfig;
    if (id == "create") {
      $ctrl.product = { id: "create" };
    } else {
      let options = {
        url: "QuerySwatchCounts.json?Id=" + id,
        autoLoad: true,
        onLoaded(args) {
          $ctrl.count = args.first;
          $ctrl.summaryQuery = new AutoQuery({
            url: $ctrl.count.countType.toUpperCase() == 'STOCK' ? "QueryStockCountSummary.json?CountId=" + id : "QuerySwatchCountSummary.json?CountId=" + id,
            autoLoad: true,
            orderBy: $ctrl.count.countType.toUpperCase() == 'STOCK' ? null : "-TimeStamp",
            pageSize: $ctrl.$pageConfig.is("gt-sm") ? 12 : 6,
          });
          $ctrl.exceptionQuery = new AutoQuery({
            url:
              $ctrl.count.countType.toUpperCase() == 'STOCK' ? "QueryStockCountExceptions.json?CountId=" +
              id +
              "&CustomSort=" +
              $ctrl.swatchConfig.customSort : "QuerySwatchCountExceptions.json?CountId=" +
              id +
              "&CustomSort=" +
              $ctrl.swatchConfig.customSort,
            autoLoad: true,
            pageSize: $ctrl.swatchConfig.customSort
              ? 5000
              : $ctrl.$pageConfig.is("gt-sm")
              ? 12
              : 6,
            onLoaded: function (args) {
              if (args.total === 0 && $ctrl.count.status === "Open") {
                modals.alert("Count is complete").result.then(function () {
                  $ctrl.count.status = "Fulfilled";
                  $ctrl.bus
                    .send("UpdateSwatchCount.json?jsconfig=ua,uaa", $ctrl.count)
                    .then(function (response) {
                      $ctrl.$emit("swatchcountSaved", $ctrl);
                      window.location.reload();
                    });
                });
              }
              $ctrl.$broadcast("swatch-scan-input", $ctrl);
            },
          });
        },
      };
      $ctrl.query = new AutoQuery(options);
      $ctrl.$on("swatchScanned", function () {
        $ctrl.summaryQuery.load(true);
        $ctrl.exceptionQuery.load(true);
      });
    }
  }
  delete(model) {
    let $ctrl = this;
    var id = model.swatchId || model.productId;
    return modals
      .confirm("Are you sure?", "Delete " + id + " from count")
      .result.then(function () {
        $ctrl.bus
          .send("DeleteSwatchCountLine", {
            CountId: $ctrl.countId,
            SwatchId: id,
          })
          .then(() => {
            $ctrl.summaryQuery.load(true);
            $ctrl.exceptionQuery.load(true);
          });
      });
  }
}
